module.exports = __webpack_public_path__ + "static/media/27-iveco.dfefc575.jpg";